import { GridValueFormatterParams } from '@mui/x-data-grid-pro'
import { store } from '@user/store/store'
import { selectSalesFunnelById } from '@user/store/salesFunnel/slice'

export const salesFunnelValueFormatter = ({
  value,
}: GridValueFormatterParams): any =>
  typeof value === 'number'
    ? selectSalesFunnelById(store.getState(), value)?.name ?? ''
    : ''
